import React from "react";
import Moment from "moment";
// import Permissions from '../../../configurations/permissions';
import ATable from "../../common/table";
import Constants from "../../../configurations/constants";
// import CButton from '../../common/connectedButton';

const SettlementRequestsTable = props => {
  const columns = [
    {
      header: "S/N",
      width: 50,
      render: row => <div>{props.paginatedCallback(row.viewIndex)}</div>
    },
    {
      header: "Log code",
      accessor: "logCode",
      render: row => {
        return row.row.logCode;
      },
      width: 90
    },

    {
      header: "Settlement Type",
      accessor: "settlementType",
      render: row => {
        return row.row.settlementType;
      }
    },

    {
      header: " Settlement Store",
      accessor: "settlementStore",
      render: row => {
        return row.row.settlementStore;
      }
    },

    {
      header: "Request Reference",
      accessor: "requestReference",
      render: row => {
        return row.row.requestReference;
      },
      width: 300
    },
    {
      header: "Status",
      accessor: "status",
      render: row => {
        return row.row.status;
      }
    },

    {
      header: "Status Message",
      accessor: "statusMessage",
      render: row => {
        return row.row.statusMessage;
      },
      width: 300
    },
    {
      header: "Created By",
      accessor: "createdBy",
      render: row => {
        return row.row.createdBy;
      }
    },

    {
      header: "Created On",
      accessor: "createdOn",
      render: row => {
        return Moment(row.row.createdOn).format(Constants.DATE_FORMAT_LONG);
      }
    }
  ];
  return (
    <ATable
      className="-striped -highlight"
      tableData={props.settlementRequests}
      columns={columns}
      onChange={props.onTableChange || null}
      onRowClick={props.onRowClick}
      manual
      {...props}
    />
  );
};

export default SettlementRequestsTable;



// WEBPACK FOOTER //
// ./src/components/settlement/settlementRequests/settlementRequestsTable.js